import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { zebra } from '../../lib/format';
import { cardPad, Th } from '../../lib/ui';

export default function Audit() {
  const { L } = useApp();

  const au = [
    { ts: '14:02:11', user: 'Maria B.', action: 'AWARD_DECISION', entity: 'RFQ-2026-001', etype: 'RFQ', ip: '10.10.1.24', hash: 'a3f9c21d8e04' },
    { ts: '14:01:55', user: 'System', action: 'RPT_DETECT', entity: 'PO-2026-0035', etype: 'RPT', ip: 'system', hash: '7b2e11aa9c3f' },
    { ts: '13:40:02', user: 'Walter A.', action: 'DOA_APPROVE', entity: 'PO-2026-0041', etype: 'PO', ip: '10.10.1.09', hash: 'c4d80f1e2ab7' },
    { ts: '11:22:47', user: 'Wendy N.', action: 'FRAUD_FLAG', entity: 'FF-2026-0018', etype: 'Override', ip: '203.150.12.7', hash: 'e91a4c7d3f20' },
    { ts: '09:14:03', user: 'Supplier A', action: 'BID_SUBMIT', entity: 'BID-2026-012', etype: 'BID', ip: '203.150.12.44', hash: '2f7b9e10c8d5' },
    { ts: '08:55:19', user: 'Maria B.', action: 'RFQ_SEND', entity: 'RFQ-2026-004', etype: 'RFQ', ip: '10.10.1.24', hash: '9c3e2a7f14bb' },
  ];
  const auditFull = au.map((a, i) => ({ ...a, zebra: zebra(i) }));

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 18px', background: 'var(--color-success-bg)', border: '1px solid var(--color-success)', borderRadius: 'var(--radius-md)', marginBottom: 16 }}>
        <Icon name="shield-check" style={{ color: 'var(--color-success)', fontSize: 20 }} />
        <div style={{ fontSize: 13, color: 'var(--color-fg-1)' }}>{L('Audit trail integrity verified. All 10 entries have valid SHA-256 hashes. Last verified: 2026-06-09 06:00 UTC.', 'ยืนยันความสมบูรณ์ของบันทึกการตรวจสอบแล้ว ทุก 10 รายการมีแฮช SHA-256 ที่ถูกต้อง ตรวจสอบล่าสุด: 2026-06-09 06:00 UTC')}</div>
        <div style={{ flex: 1 }} />
        <button className="hv-white" style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 14px', border: '1px solid var(--color-success)', borderRadius: 'var(--radius-sm)', fontSize: 13, fontWeight: 600, color: 'var(--color-success)', background: 'transparent' }}>
          <Icon name="download" />{L('Export CSV', 'ส่งออก CSV')}
        </button>
      </div>

      <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
        <div style={{ position: 'relative', flex: 1, minWidth: 200, maxWidth: 300 }}>
          <Icon name="search" style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', color: 'var(--color-fg-3)', fontSize: 16 }} />
          <input placeholder={L('Search…', 'ค้นหา…')} style={{ width: '100%', padding: '9px 12px 9px 34px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', background: 'var(--color-white)' }} />
        </div>
        <select style={{ padding: '9px 12px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', background: 'var(--color-white)' }}>
          <option>{L('All entity types', 'ทุกประเภทเอนทิตี')}</option>
          <option>RFQ</option>
          <option>PO</option>
          <option>BID</option>
          <option>Override</option>
          <option>Supplier</option>
          <option>COI</option>
          <option>RPT</option>
        </select>
        <select style={{ padding: '9px 12px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', background: 'var(--color-white)' }}>
          <option>{L('All actions', 'ทุกการกระทำ')}</option>
          <option>AWARD_DECISION</option>
          <option>DOA_APPROVE</option>
          <option>FRAUD_FLAG</option>
          <option>BID_SUBMIT</option>
          <option>RFQ_SEND</option>
        </select>
      </div>

      <div style={cardPad(0, 'auto')}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, minWidth: 860 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
              <Th>{L('Timestamp', 'เวลา')}</Th>
              <Th>{L('User', 'ผู้ใช้')}</Th>
              <Th>{L('Action', 'การกระทำ')}</Th>
              <Th>{L('Entity', 'เอนทิตี')}</Th>
              <Th>{L('Type', 'ประเภท')}</Th>
              <Th>{L('IP Address', 'ที่อยู่ IP')}</Th>
              <Th>{L('Hash', 'แฮช')}</Th>
            </tr>
          </thead>
          <tbody>
            {auditFull.map((a, i) => (
              <tr key={i} style={{ borderBottom: '1px solid var(--color-border)', background: a.zebra }}>
                <td style={{ padding: '10px 16px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-2)' }}>{a.ts}</td>
                <td style={{ padding: '10px 16px', fontWeight: 600 }}>{a.user}</td>
                <td style={{ padding: '10px 16px' }}>
                  <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 'var(--radius-sm)', background: 'var(--color-ink-50)', color: 'var(--color-fg-2)' }}>{a.action}</span>
                </td>
                <td style={{ padding: '10px 16px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-2)' }}>{a.entity}</td>
                <td style={{ padding: '10px 16px' }}>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 999, background: 'var(--color-ink-50)', color: 'var(--color-fg-2)' }}>{a.etype}</span>
                </td>
                <td style={{ padding: '10px 16px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-3)' }}>{a.ip}</td>
                <td style={{ padding: '10px 16px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-3)' }}>{a.hash}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
